/* Copyright (c) 2021 Paul Nebel */

import React from 'react';
import PropTypes from 'prop-types';

import Metronome from '../components/metronome';
import MetronomeIndicator from '../components/metronome-indicator';


export default class MetronomeContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            volume: props.volume,
            bpm: props.bpm,
        };
    }

    render() {
        const renderBeats = () => {
            const beats = [];
            for (let i=0; i < 4; i = i + 1) {
                beats.push(
                    <div
                        className='column is-3 has-text-centered'
                        key={ `metro-${i}` }
                    >
                        <MetronomeIndicator
                            noteIndex={ i }
                            baseClassName={ this.props.baseClassName }
                            animationClassName={ this.props.animationClassName }
                        />
                    </div>
                );
            }
            return beats;
        };
        return (
            <div className='columns is-flex-direction-column'>
                <div className='column'>
                    <Metronome
                        volume={ this.state.volume }
                        bpm={ this.state.bpm }
                    />
                </div>
                <div className='column'>
                    <div className='columns is-mobile'>
                        { renderBeats() }
                    </div>
                </div>
            </div>
        );
    }
}

MetronomeContainer.propTypes = {
    animationClassName: PropTypes.string,
    baseClassName: PropTypes.string,
    volume: PropTypes.number,
    bpm: PropTypes.number,
};

MetronomeContainer.defaultProps = {
    animationClassName: 'fade_green',
    baseClassName: 'mc',
    volume: -6,
    bpm: 120,
};
